import React from 'react';

interface SparkleGradientProps {
    id: string;
}

/**
 * Runs from the midpoint of the left and top tips to the midpoint of the right and bottom tips, so
 * those tips hold the end colours. User space, so the burst grains take the colour of where they sit.
 */
export const SparkleGradient: React.FC<SparkleGradientProps> = ({ id }) => (
    <defs>
        <linearGradient id={id} gradientUnits="userSpaceOnUse" x1="13.62" y1="14.67" x2="28.62" y2="29.67">
            <stop offset="0" style={{ stopColor: 'var(--color-sparkle-from)' }} />
            <stop offset="0.5" style={{ stopColor: 'var(--color-sparkle-via)' }} />
            <stop offset="1" style={{ stopColor: 'var(--color-sparkle-to)' }} />
        </linearGradient>
    </defs>
);
